import {BaseEntityConfig, WhiteListFields} from '~/redux/base-entity-config';
import {QuestionnaireEntity} from '~/types/models/questionnaire';

class EntityConfig extends BaseEntityConfig<QuestionnaireEntity> {
  entityKey = 'questionnaires';

  associates = [];

  whiteListFields: WhiteListFields<QuestionnaireEntity> = ['*'];

  getAccessors = (value: QuestionnaireEntity) => {
    //
  };
}

const questionnaireEntConf = new EntityConfig();

export const questionnaireSchema = questionnaireEntConf.getEntitySchema();

export default questionnaireEntConf;

export const SOURCES_QUESTIONNAIRE = {
  QUESTIONNAIRES_PAGE: 'QUESTIONNAIRES_PAGE',
};
